<template>
  <div>
    <v-card
      flat
      style="
        border: 1px solid hsl(214.3 31.8% 91.4%);
        border-radius: 0.5rem;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      "
      v-if="(!post.post || post.skip) && !post.processed"
    >
      <v-sheet
        style="
          font-size: 9pt;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        "
        class="text-center py-1 d-flex align-center justify-center"
        :color="
          post.skip
            ? 'info'
            : categories.find((c) => c.uid === post.category)?.color
        "
        :style="{
          color:
            categories.find((c) => c.uid === post.category)?.color === '#272727'
              ? 'white'
              : '#272727',
        }"
      >
        <v-tooltip
          :text="
            !post.active
              ? 'This category is paused and will not be published in this slot.'
              : 'This post is skipped'
          "
        >
          <template v-slot:activator="{ props }">
            <div v-bind="props">
              {{ post.skip ? "Skipped" : post.active ? "Scheduled" : "Paused" }}
              <v-icon v-if="post.skip" size="12" class="ml-2"
                >mdi-debug-step-over</v-icon
              >
              <v-icon v-if="!post.active" size="12" class=""
                >mdi-information-outline</v-icon
              >
            </div>
          </template>
        </v-tooltip>
      </v-sheet>
      <v-divider class="primary"></v-divider>
      <div class="pa-3" style="font-size: 10pt" v-if="post.skip">
        This slot is empty and will be skipped.
        <v-btn
          class="mt-3"
          variant="tonal"
          size="x-small"
          @click="updateSkip(false)"
          :loading="updatingSkip"
          >Don't skip</v-btn
        >
      </div>
      <div class="pa-3" style="font-size: 10pt" v-else-if="!post.empty_queue">
        This slot for
        <b>{{ categories.find((c) => c.uid === post.category)?.name }}</b> will
        be filled automatically.
      </div>
      <div class="pa-3" style="font-size: 10pt" v-else-if="post.empty_queue">
        Add more <u>active</u> posts to
        <b>{{ categories.find((c) => c.uid === post.category)?.name }}</b> to
        fill this slot.
      </div>
    </v-card>

    <v-card
      flat
      style="
        border: 1px solid hsl(214.3 31.8% 91.4%);
        border-radius: 0.5rem;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
      "
      v-else-if="post && post.post"
    >
      <div v-if="post.schedule || post.published || post.unix">
        <v-sheet
          v-if="post.published"
          style="
            font-size: 9pt;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: #272727;
          "
          class="py-1 d-flex align-center justify-space-between px-2"
          color="success"
        >
          <div>
            <span class="font-weight-medium text-muted">Published:</span>
            <p class="font-weight-bold">{{ publish_timestamp }}</p>
          </div>
        </v-sheet>

        <v-sheet
          v-else-if="!post.published && post.publish_results?.error"
          style="
            font-size: 9pt;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: #272727;
          "
          class="py-1 d-flex align-center justify-space-between px-2"
          color="error"
        >
          <div>
            <span class="font-weight-medium text-white">Not published</span>
            <p class="font-weight-bold text-white">Something went wrong.</p>
          </div>
        </v-sheet>

        <v-sheet
          v-else-if="
            (post.schedule || post.unix) &&
            !post.published &&
            (post.active || post.scheduled)
          "
          style="
            font-size: 9pt;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
          "
          class="py-1 d-flex align-center justify-space-between px-2"
          :color="categories.find((c) => c.uid === post.post.category)?.color"
          :style="{
            color:
              categories.find((c) => c.uid === post.post.category)?.color ===
              '#272727'
                ? 'white'
                : '#272727',
          }"
        >
          <div>
            <span class="font-weight-medium text-muted">Scheduled:</span>
            <p class="font-weight-bold">{{ scheduled_at }}</p>
          </div>
          <v-menu transition="slide-y-transition" bottom>
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-dots-vertical"
                variant="text"
                size="small"
              ></v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="!post.post.schedule_date"
                link
                class="px-4"
                @click="updateSkip(true)"
              >
                <v-icon size="small" color="primary" class="mr-3"
                  >mdi-debug-step-over</v-icon
                >
                Skip this slot
              </v-list-item>
              <v-list-item
                link
                class="px-4"
                v-if="post.post.recurring || !post.post.last_publish"
                @click="$store.dispatch('loadPost', post.post.uid)"
              >
                <v-icon size="small" color="primary" class="mr-3"
                  >mdi-pencil</v-icon
                >
                Preview & Edit
              </v-list-item>

              <v-list-item
                v-if="userProfile.superadmin"
                link
                class="px-4"
                @click="openInFb(workspace.uid, post.post.uid)"
              >
                <v-icon size="small" color="primary" class="mr-3"
                  >mdi-firebase</v-icon
                >
                Firebase
              </v-list-item>
            </v-list>
          </v-menu>
        </v-sheet>

        <v-sheet
          v-else-if="!post.active && !post.scheduled"
          style="
            font-size: 9pt;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: #272727;
          "
          class="py-1 d-flex align-center justify-center px-2"
        >
          <v-tooltip
            width="300"
            text="
           This is a preview. Activate the category to start publishing
          "
          >
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                Paused

                <v-icon v-if="!post.active" size="12" class=""
                  >mdi-information-outline</v-icon
                >
              </div>
            </template>
          </v-tooltip>
        </v-sheet>

        <v-divider class="primary"></v-divider>
      </div>

      <div class="pa-2" v-if="updatingSkip">
        <v-sheet rounded color="info" class="pa-2" style="font-size: 10pt">
          <v-progress-circular
            size="13"
            width="1"
            indeterminate
            class="mr-2"
          ></v-progress-circular>
          Skipping...</v-sheet
        >
      </div>

      <div
        v-else-if="
          (post.post && post.post.link_preview) ||
          (post.post && post.post.media && post.post.media.length > 0)
        "
        class="mb-3"
      >
        <div
          v-if="post.post.media[0].extension === 'pdf'"
          style="max-height: 200px; width: 200px; overflow: auto"
        >
          <VuePdfEmbed :source="post.post.media[0]?.src" width="200" />
        </div>
        <v-img
          v-else-if="post.post.media[0].type === 'image'"
          style="max-width: 100%; object-fit: contain"
          :src="getSrc(post.post.media[0])"
        />
      </div>

      <div class="px-3 pb-3 py-2" v-if="post.post">
        <p
          class="mb-0"
          :class="{
            'line-clamp-short': post.post.media || post.post.link_preview,
            'line-clamp': !post.post.media && !post.post.link_preview,
          }"
          style="font-size: 10pt"
        >
          {{ post.post.variation?.text?.replace(/@\[(.*?)\]\(.*?\)/g, "@$1") }}
        </p>
      </div>

      <div
        class="pa-3 d-flex align-center flex-wrap"
        style="gap: 5px"
        v-if="categories.find((c) => c.uid === post.post.category)"
      >
        <v-chip
          size="small"
          label
          variant="flat"
          :color="categories.find((c) => c.uid === post.post.category)?.color"
          class="primary--text font-weight-medium"
          ><span>{{
            categories.find((c) => c.uid === post.post.category)?.name
          }}</span></v-chip
        >
        <v-spacer></v-spacer>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { DateTime } from "luxon";
import VuePdfEmbed from "vue-pdf-embed";
export default {
  components: {
    VuePdfEmbed,
  },
  props: {
    calendar_uid: {
      type: String,
      default: null,
    },
    post: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      categories: (state) => state.posts.categories,
      workspace: (state) => state.workspace.workspace,
    }),
    publish_timestamp() {
      let time = null;
      if (this.post.publish_timestamp) {
        time = DateTime.fromSeconds(this.post.publish_timestamp).setZone(
          this.workspace.timezone,
        );
      }
      return time ? time.toFormat("HH:mm") : null;
    },
    scheduled_at() {
      let time = null;
      if (this.post.unix) {
        time = DateTime.fromSeconds(this.post.unix).setZone(
          this.workspace.timezone,
        );
      }
      return time ? time.toFormat("HH:mm") : null;
    },
  },
  data() {
    return {
      updatingSkip: false,
    };
  },
  methods: {
    getSrc(media) {
      console.log(media);
      if (media.thumbnail?.src) {
        return media.thumbnail.src;
      } else if (media.thumbnail) {
        return media.thumbnail;
      } else {
        return media.src;
      }
    },
    openInFb(ws, post) {
      let production = window.location.origin.includes("app.stix.social");
      let url = `https://console.firebase.google.com/u/0/project/${
        production ? "one-startup-stack" : "stix-staging-f240f"
      }/firestore/data/~2Fworkspaces~2F${ws}~2Fposts~2F${post}`;
      window.open(url, "_blank");
    },
    async updateSkip(val) {
      this.updatingSkip = true;
      await this.$store.dispatch("updateSkip", {
        calendar_uid: this.calendar_uid,
        post_uid: this.post.uid,
        skip: val,
      });
      this.updatingSkip = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.line-clamp-short {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
